<ntap-view-window target="globalDialog"></ntap-view-window>
<ng-container *ngIf="jediniceViewState">
    <ng-container ntapFilterViewProvider [viewName]="jediniceViewName" [viewState]="jediniceViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="jediniceViewName" [viewState]="jediniceViewState">
            <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>